import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Carousel, CarouselItem} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Carousel, {
        'clonedAmount': 2,
        'children': [
            _$cc(CarouselItem, {
                'className': 'one',
                'children': '1'
            }),
            _$cc(CarouselItem, {
                'className': 'two',
                'children': '2'
            }),
            _$cc(CarouselItem, {
                'className': 'three',
                'children': '3'
            }),
            _$cc(CarouselItem, {
                'className': 'four',
                'children': '4'
            })
        ]
    });
};